import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './Carousel.module.scss';

interface CarouselItem {
  image: string;
  legend: string;
}

interface CarouselProps {
  items: CarouselItem[];
}

const Carousel: React.FC<CarouselProps> = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={styles.carousel}>
      <div className={styles.carouselInner}>
        <button
          className={`${styles.carouselButton} ${styles.carouselButtonPrev}`}
          onClick={goToPrevious}
          aria-label="Anterior"
        >
          <ChevronLeft size={24} />
        </button>

        <div className={styles.carouselSlides}>
          {items.map((item, index) => (
            <div
              key={index}
              className={`${styles.carouselSlide} ${
                index === currentIndex ? styles.active : ''
              }`}
            >
              <img src={item.image} alt={item.legend} />
              <p className={styles.legend}>{item.legend}</p>
            </div>
          ))}
        </div>

        <button
          className={`${styles.carouselButton} ${styles.carouselButtonNext}`}
          onClick={goToNext}
          aria-label="Siguiente"
        >
          <ChevronRight size={24} />
        </button>
      </div>

      <div className={styles.carouselIndicators}>
        {items.map((_, index) => (
          <button
            key={index}
            className={`${styles.indicator} ${index === currentIndex ? styles.active : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Ir a imagen ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;

